import { Component, OnInit } from '@angular/core';
import { RouterLink }          from '@angular/router';

@Component({
    selector: 'enlist-form',
    templateUrl: './enlist-form.component.html'
})
export class EnlistFormComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
